<script setup lang="ts">
import type { HTMLAttributes } from "vue";

const attrs = useAttrs();

const props = withDefaults(
  defineProps<{
    tag: string;
    size?: "sm" | "md" | "lg";
    count?: number;
    bgClass?: HTMLAttributes["class"];
    textClass?: HTMLAttributes["class"];
  }>(),
  { tag: "div", size: "md" }
);

const classes = computed(() => [
  "app-map-marker",

  props.bgClass || "bg-black",
  props.textClass || "text-white",

  "relative",
  "flex items-center justify-center",
  "shadow-[0px_0px_6.2px_2px_rgba(0,_0,_0,_0.1)]",
  "transform -translate-x-1/2 translate-y-full",

  "cursor-pointer",
  "!pointer-events-auto",

  {
    "app-map-marker--sm w-8 h-8 rounded-s-lg rounded-b-lg": props.size === "sm",
    "app-map-marker--md w-10 h-10 rounded-s-xl rounded-b-xl":
      props.size === "md",
    "app-map-marker--lg w-12 h-12 rounded-s-2xl rounded-b-2xl":
      props.size === "lg",
  },
]);
</script>

<template>
  <component :is="props.tag" :class="classes" v-bind="attrs">
    <span
      v-if="props.count || $slots['count']"
      :class="[
        'app-map-marker__count',
        'absolute top-0 right-0',
        'translate-x-1/2 -translate-y-1/2',
        'rounded-full',
        'bg-black text-white',
        'h-6 min-w-6 w-auto',
        'px-1',
        'flex items-center justify-center',
        'font-semibold text-base leading-3',
      ]"
    >
      <slot name="count" v-bind="{ props }">
        {{ props.count }}
      </slot>
    </span>

    <slot></slot>
  </component>
</template>
